// Don't use `rem` units for anything since existing CSS `font-size` affects all rem units
// https://github.com/am-systems/am-web-properties/blob/c1d44502a5babfe955a7f7462eba23658a73bbe3/public/thecreditreview/css/top-services/media-query.css#L22-L25.
// Existing `rem` units are migrated values from old styles to avoid breaking layouts.
export const getStyles = ({ awardText }) => ({
	featuredCompanyHeader: {
		wrapper:
			"tw:bg-[#ebf4ff] tw:text-center tw:text-balance tw:rounded-t-[3px]",
		contentWrapper: "tw:text-black tw:font-bold tw:leading-8 tw:text-[16px]",
	},
	serviceFlag: {
		wrapper: "tw:absolute tw:top-[9px] tw:left-[-3px] tw:flex",
		flag: `tw:w-[44px] tw:h-[44px] tw:bg-[#1d8ce0] tw:flex tw:items-center tw:justify-center tw:rounded-[3px] tw:border tw:border-solid tw:border-[#1d8ce0] ${awardText ? "tw:xs2:rounded-r-none" : ""}`,
		number:
			"tw:text-white tw:text-[1.5rem] tw:font-avenirNextDemi tw:m-0 tw:pt-[4px] tw:leading-[1.4286]",
		text: "tw:hidden tw:xs2:flex tw:items-center tw:justify-center tw:relative tw:pt-[3px] tw:pl-[8px] tw:h-[44px] tw:w-[70px] tw:bg-[#333742] tw:uppercase tw:text-white tw:text-[12px] tw:font-avenirNextDemi tw:font-semibold tw:leading-none tw:after:absolute tw:after:right-[-16px] tw:after:top-0 tw:after:[border-left:16px_solid_#333742] tw:after:[border-top:22px_solid_transparent] tw:after:[border-bottom:22px_solid_transparent]",
	},
	companyLogo: {
		picture: "tw:w-full tw:text-center tw:xs2:max-w-[300px]",
		image: "tw:max-w-[55%]",
	},
	cafNumber:
		"tw:text-center tw:block tw:bottom-[10px] tw:w-full tw:text-[12px] tw:font-medium tw:tracking-[0.024em] tw:text-[#333742] tw:font-avenirNextDemi tw:mt-[10px]",
	rightSecitonReviewLink: {
		wrapper:
			"tw:hidden tw:md:flex tw:items-center tw:justify-center tw:mt-[8px] tw:desktop:absolute tw:desktop:bottom-[14px] tw:desktop:mt-0",
		text: "tw:text-[12px] tw:font-avenirNextDemi tw:pt-[3px] tw:leading-[12px] tw:text-[#333742] tw:uppercase tw:tracking-[0.024em] tw:font-medium",
	},
	callOut:
		"tw:inline-block tw:w-fit tw:px-[10px] tw:py-[7px] tw:pb-[5px] tw:tracking-wider tw:mt-[7px] tw:leading-none tw:bg-white tw:border-2 tw:border-solid tw:border-[#1d8ce0] tw:rounded-[3px] tw:shadow-[0_3px_9px_rgba(59,59,59,0.28)] tw:text-[#1d8ce0] tw:font-montserrat tw:text-[12px] tw:font-bold tw:uppercase",
	ratingSection: {
		wrapper:
			"tw:w-[300px] tw:mx-auto tw:px-[10px] tw:py-[5px] tw:bg-[#f8fafa] tw:flex tw:items-center tw:justify-between tw:rounded-[3px] tw:border tw:border-solid tw:border-[#d6dbdf] tw:font-avenirNextDemi tw:desktop:border-none tw:desktop:flex-col tw:desktop:justify-center tw:desktop:w-[150px] tw:desktop:mx-[initial]",
		ratingLabel:
			"tw:text-[12px] tw:uppercase tw:tracking-wide tw:text-[#71777a] tw:leading-[12px] tw:desktop:[&>br]:hidden",
		ratingValue:
			"tw:text-[#333742] tw:text-[30px] tw:leading-[1.4286] tw:desktop:text-[3rem] tw:desktop:leading-normal tw:desktop:order-1 tw:desktop:mb-[10px] tw:desktop:mt-[5px]",
		colorBar: {
			wrapper:
				"tw:flex tw:w-full tw:items-center tw:justify-around tw:shadow-lg tw:bg-white tw:max-w-[114px] tw:py-[3px] tw:px-[2px] tw:desktop:order-2",
			bar: "tw:block tw:w-[9px] tw:h-[10px]",
		},
	},
	benefitsList: {
		wrapper: "",
		list: "",
		listItem:
			"tw:mb-[6px] tw:last:mb-0 tw:pl-[25px] tw:text-pretty tw:text-[#48484b] tw:text-[16px] tw:font-semibold tw:leading-[1.4286] tw:bg-[url(/public/react-images/common/iconTick.svg)] tw:bg-no-repeat tw:bg-position-[left_top_5px] tw:desktop:text-[14px]",
		expandButton:
			"tw:mb-5 tw:w-full tw:flex tw:cursor-pointer tw:items-center tw:border-0 tw:bg-transparent tw:py-0 tw:pl-[25px]",
		expandBenefitsContent:
			"tw:text-[16px] tw:text-[#48484b] tw:pt-[2px] tw:leading-[1.4286]",
		expandButtonIcon:
			"tw:ml-[2px] tw:text-[20px] tw:rotate-90 tw:text-[#48484b]/70",
	},
	visitLink: {
		wrapper: "tw:flex tw:gap-[4px]",
		contentWrapper: "tw:leading-[1.1]",
		iconClass:
			"tw:hidden tw:text-3xl tw:text-white tw:transition-all tw:duration-300 tw:group-hover:translate-x-1 tw:md:inline-flex tw:items-center tw:justify-center",
	},
	reviewLink: {
		wrapper:
			"tw:text-center tw:text-[#1d8ce0] tw:text-[14px] tw:font-semibold tw:leading-[1.4286] tw:desktop:mx-auto tw:[border-bottom:1px_dashed] tw:mt-[10px]",
		text: "",
	},
});
